import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname || "/";
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        toast.success(`Welcome, ${r.data.name}`);
      } catch {
        toast.error("Google sign-in failed, please try again");
      } finally {
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true });
      }
    })();
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <span className="kp-eyebrow">Signing you in…</span>
    </div>
  );
};
